import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.lg,
		maxWidth: 720,
	},
	runNowContainer: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-end',
		gap: 8,
	},
	field: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	label: {
		color: THEME.colors.text.main,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	requiredIndicator: {
		color: THEME.colors.danger.main,
	},
	helpText: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	statusLine: {
		color: THEME.colors.text.light,
		fontSize: THEME.typography.fontSizes.xs,
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		gap: THEME.spacing.sm,
		marginTop: THEME.spacing.sm,
	},
	textArea: {
		minHeight: 128,
	},
});
